<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <v-select
      :class="evaluateClasses(classes)"
      :items="getValues()"
      :label="model.Caption"
      :value="model.Value"
      :disabled="isDisabled"
      :regular="isRegular"
      :solo="isSolo"
      :outlined="isOutlined"
      :filled="isFilled"
    ></v-select>
  </dr-wrapper>
  <v-select v-bind="$props"
    v-else-if="isVisible"
    ref="drDropDownRef"
    :class="evaluateClasses(classes)"
    :items="getValues()"
    :value="model.Value"
    :rules="_isRequiredField"
    :disabled="isDisabled" 
    :regular="isRegular"
    :solo="isSolo"
    :outlined="isOutlined"
    :filled="isFilled"
    @change="invokeActionOnClick(model.GenerationOnChange, { value: $event })"
  >
    <template v-if="model.Caption || model.Required" #label>
      <span v-if="model.Caption">{{ model.Caption }}</span>
      <span v-if="model.Required" class="dr-drop-down-required-hint">*</span>
    </template>
  </v-select>
</template>

<script>

import inputMixin from '../../mixins/input-mixin'
import baseMixin from '../../mixins/base-mixin'
import actionMixin from '../../mixins/actions-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import inputWidgetsValidateMixin from '../../mixins/input-widgets-validate-mixin'

export default {
  mixins: [inputMixin, baseMixin, actionMixin, widgetsWrapperMixin, inputWidgetsValidateMixin],

  computed: {
    _isRequiredField() {
      if (!this.model.Required) {
        return []
      }
      return [val => (val || '').length > 0 || `${this.model.Caption} - ${this.$t('vuetifyWidgets.dr-text-field.required')}`]
    }
  },

  methods: {
    getValues() {
      return this.model.Items.split(',')
    }
  }
}
</script>

<style>
.dr-drop-down-required-hint {
  font-size: 25px;
  color: red;
}
</style>
